
/*
  toTitleCase
  -> "this is a string".toTitleCase() => "This Is A String"
 */
String.prototype.toTitleCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};
